/**
 * Array of days of the week
 */
const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']

module.exports = days
